const PrintListLanding = ({ id = "", list = [] }) => {
  if (list?.length === 0) {
    return null;
  }
  return (
    <>
      {typeof list === "string" ? (
        <li>{list}</li>
      ) : (
        list?.length > 0 &&
        list?.map((item, index) => <li key={`${id}${index}`}>• {item}</li>)
      )}
    </>
  );
};

export default PrintListLanding;
